import { useLocation } from "react-router-dom";

import __ from "web/Layout/Translations";

import urls from "web/constants/urls";

import { useAppContext } from "web/context/app";

import { CUSTOMER_CONTENT_ID, MAIN_CONTENT_ID } from "../const";
import styles from "./skipToContent.scss";

const SkipToContent = () => {
  const { pathname } = useLocation();
  const { isMobile } = useAppContext();

  // for desktop customer panel - skip also customer aside nav
  const contentId =
    pathname.includes(urls.customer) && !isMobile
      ? CUSTOMER_CONTENT_ID
      : MAIN_CONTENT_ID;

  return (
    <a href={`#${contentId}`} className={styles.skipToContent}>
      {__("Przejdź do treści")}
    </a>
  );
};

export default SkipToContent;
